import React from 'react'
import { Section } from '@shared/components/section'
import Geo from '@shared/svg/geo.svg'

import styles from './style.module.scss'

export const View = () => (
	<Section className={styles.wrapper}>
		<Geo className={styles.map} />
		<div className={styles.text}>
			<h2 className={styles.title}>Уже в 100 городах России</h2>
			<h3 className={styles.h4}>
				Главный офис находится в&nbsp;Екатеринбурге, но&nbsp;мы&nbsp;помогаем людям по&nbsp;всей
				России.
			</h3>
		</div>
	</Section>
)
